"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-us" className="bg-background py-16 px-6 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-4xl">
        <div ref={headingRef} className={`mb-8 text-center transition-all duration-700 ${headingVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
            About Us
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-primary"></div>
        </div>

        <div ref={contentRef} className={`transition-all duration-700 delay-200 ${contentVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="rounded-lg bg-muted p-8 shadow-soft sm:p-10 lg:p-12">
            <p className="mb-6 text-base leading-relaxed text-foreground sm:text-lg">CashHome was founded with a simple mission: to transform the way homeowners sell their properties. We recognized that the traditional real estate process could be slow, expensive, and stressful. That's why we built a nationwide service dedicated to providing fast, hassle-free cash offers for houses across the country.</p>
            <p className="mb-6 text-base leading-relaxed text-foreground sm:text-lg">
              From day one, we've been committed to transparency and trust. By
              eliminating financing delays and covering all title fees, closing
              fees, and transfer fees, we ensure that homeowners can sell
              quickly without any out-of-pocket costs. Our streamlined process
              includes a quick property evaluation, clear pricing, and a
              dedicated team that handles all the paperwork from start to
              finish.
            </p>
            <p className="text-base leading-relaxed text-foreground sm:text-lg">
              Today, CashHome stands as a reliable partner for homeowners
              seeking rapid, effortless transactions. We're proud to serve
              communities nationwide, delivering immediate liquidity and peace
              of mind to those who need it most.
            </p>
          </div>
        </div>
      </div>
    </section>;
}